$(document).ready(function() {
  if ($(window).width() <= 768) {

    function sticky_relocate() {
        var window_top = jQuery(window).scrollTop();
        var div_top = jQuery('#ProductGridContainer').offset().top;
        var div_height = jQuery('#ProductGridContainer').outerHeight() - 800;
        var div_bottom = div_top + div_height;

        if (window_top > 50 && window_top > div_top && window_top < div_bottom) {
            jQuery('.oneline-main').addClass('stick').css('opacity', 1);
        } else if (window_top >= div_bottom) {
            jQuery('.oneline-main').css('opacity', 0);
        } else {
            jQuery('.oneline-main').removeClass('stick').css('opacity', 1);
        }
    }

    (function($) {
        $(window).scroll(sticky_relocate);
        sticky_relocate();
    })(jQuery);
    
}
});

// Model Popup

 $(document).ready(function () {
  $('.trigger-popup').each(function () {
    let trigger = $(this).attr('data-popup-id');
    let modal = $('#' + trigger);
    // Open Popup
    $(this).click(function () {
      $(modal).fadeIn();
      $("body").addClass('active');
      $(this).addClass('active-animation');
      $(".close-popup").addClass('btn-animation');
    });
    // Close Popup when close button is clicked
    $(modal).find('.close-popup').click(function () {
      $(modal).fadeOut();
      $("body").removeClass('active');
      $(".trigger-popup").removeClass('active-animation');
      $(".close-popup").removeClass('btn-animation');
    });
    // Close Popup when overlay is clicked
    $(modal).find('.popup-overlay').click(function (event) {
      if (event.target !== this) return;
      $(modal).fadeOut();
      $("body").removeClass('active');
      $(".trigger-popup").removeClass('active-animation');
      $(".close-popup").removeClass('btn-animation');
    });
    // Close Popup on Escape key press
    $(document).keydown(function (e) {
      if (e.key === 'Escape') {
        $(modal).fadeOut();
        $("body").removeClass('active');
        $(".trigger-popup").removeClass('active-animation');
        $(".close-popup").removeClass('btn-animation');
      }
    });
  });

document.addEventListener('click', function (e) {
  if (e.target.closest('.hide__on_desktopp23 .carousel-main .swiper-slide-active .product-single__media-image')) {
    const zoomBtn = document.querySelector('.hide__on_desktopp23 .carousel-main .swiper-slide-active .product-single__media-zoom');
    if (zoomBtn) {
      zoomBtn.click(); // native click → Fancybox will catch this
    }
  }
});
  if ($(window).width() <= 768) {
    $(document).on('click', '.global_condition1', function () {
        $(this).find('button[data-fancybox]').first()[0].click();
    });
  }

});